export * from './project-carousel-item';
export * from './project-carousel-item-bottom';
export * from './project-details';
export * from './export-header';

import { ExportHeaderComponent } from './export-header';
import { ProjectCarouselItemComponent } from './project-carousel-item';
import { ProjectCarouselItemBottomComponent } from './project-carousel-item-bottom';
import { ProjectDetailsComponent } from './project-details';



export const ProjectAtoms = [
    ProjectCarouselItemComponent,
    ProjectCarouselItemBottomComponent,
    ProjectDetailsComponent,
    ExportHeaderComponent
]